import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import { FC, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Form, FormikValues, useFormikContext } from "formik";

import { createIRBInitData } from "../utils";
import StudyDetails from "./StudyDetails/StudyDetails";
import IRBSubmission from "./IRBSubmission/IRBSubmission";
import ProgressSteps from "../../../../common/ProgressSteps/ProgressSteps";
import { useGetIrbSubmissionInfoLazyQuery } from "../../../../../generated/graphql";
import CreatePageFormFooter from "../../../../common/Form/CreatePageFormFooter/CreatePageFormFooter";
import moment from "moment";
import { DATE_OF_IRB_SUBMISSION, IS_TERMS_ACCEPTED } from "../../../../../constants/forms";

interface IProps {
  steps: number;
  setSteps(step: number): void;
  stepsInfo: string[];
}

const CreateIRBSubmissionForm: FC<IProps> = (props) => {
  const { steps, setSteps, stepsInfo } = props;

  const { id } = useParams();

  const [getIrbById] = useGetIrbSubmissionInfoLazyQuery();

  const { setValues } = useFormikContext<FormikValues>();

  useEffect(() => {
    if (id) {
      const getData = async () => {
        const res = await getIrbById({
          variables: { id },
        });
        const newFormValues = {
          ...createIRBInitData,
          ...res.data?.irb,
          [IS_TERMS_ACCEPTED]: true,
          [DATE_OF_IRB_SUBMISSION]: moment().format("yyyy-MM-DD")
        };
        setValues({ ...newFormValues });
      };
      getData();
    }
  }, [getIrbById, setValues, id]);

  return (
    <Form>
      <Container maxWidth={false}>
        <Card>
          <CardContent className="pd-x-32 pd-t-32 pd-b-20">
            <Box className="mg-b-40">
              <Typography className="mg-b-10" variant="h2" component="h2">
                MIRB Submission Creation
              </Typography>
              <ProgressSteps stepsInfo={stepsInfo} currentStep={steps} />
            </Box>
            <Grid container className="justify-content-center">
              <Grid item xs={12} md={10} lg={10}>
                {steps === 0 && <StudyDetails />}
                {steps === 1 && <IRBSubmission />}
                <CreatePageFormFooter
                  id={id}
                  setSteps={setSteps}
                  steps={steps}
                  stepsInfo={stepsInfo}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>
    </Form>
  );
};

export default CreateIRBSubmissionForm;
